import React from 'react';
import classNames from 'classnames';
import LabelInput from '../form/LabelInput';

export default function Input({ label, comp, placeholder, type, ...rest }) {
  return (
    <LabelInput
      labelProps={{
        className: classNames(
          'input',
          `${type ? 'input_' + type : ''}`,
          comp,
          Object.values(rest?.error?.props?.errors[rest.name] || {}).length ? 'input_error' : '',
        ),
      }}
      label={label ? <div className={'input__name'}>{label}</div> : null}
      className='input__block'
      placeholder={placeholder}
      spellCheck={false}
      maxLength={`${rest.max ? rest.max : null}`}
      type={type}
      id={rest?.name}
      {...rest}
    />
  );
}
